import React from 'react';
import PropTypes from 'prop-types';
import PendingListCardVariant from '../../../../_shared/constants/pendingListCardVariant';
import TradeHeader from '../../ListTradeCard/Content/TradeHeader';
import TradeDisclosures from '../../ListTradeCard/Content/TradeDisclosures';
import TradeCardTitle from '../TradeCardTitle';
import { TradeContext } from '../../../../_shared/types/trade';
import KebabMenuSeller from '../KebabMenuSeller';
import { ContentContainer, StyledTitle } from './Styles';
import DISTANCE_UNITS from '../../../../_shared/types/distanceUnits';
import { getTransmissionType } from '../../../../_shared/models/TradeList';

const propTypes = {
  testId: PropTypes.string.isRequired,
  tradeSummary: PropTypes.shape({
    id: PropTypes.number,
    mileage: PropTypes.number,
    odometerType: PropTypes.number,
    transmission: PropTypes.shape({
      id: PropTypes.number
    }),
    asIs: PropTypes.bool,
    hasDisclosures: PropTypes.bool,
    isTrdSeller: PropTypes.bool,
    inStock: PropTypes.bool,
    distanceBucket: PropTypes.number,
    isWatchlisted: PropTypes.bool,
    trim: PropTypes.string
  }).isRequired,
  onCardClick: PropTypes.func.isRequired,
  tradeContext: PropTypes.oneOf([TradeContext.Buy, TradeContext.Sell])
    .isRequired,
  sellingNetworks: PropTypes.arrayOf(PropTypes.object),
  isOpenNetwork: PropTypes.bool,
  listCardVariant: PropTypes.string,
  isOmp: PropTypes.bool
};

const defaultProps = {
  sellingNetworks: undefined,
  isOpenNetwork: false,
  listCardVariant: '',
  isOmp: false
};

const Content = ({
  testId,
  tradeSummary,
  onCardClick,
  tradeContext,
  sellingNetworks,
  isOpenNetwork,
  setPendingCardFooter,
  listCardVariant,
  isOmp
}) => {
  const {
    hasDisclosures,
    asIs,
    inStock,
    mileage,
    odometerType,
    transmission,
    trim,
    vin,
    id: tradeId,
    hasChat
  } = tradeSummary;

  const isSellContext = tradeContext === TradeContext.Sell;

  return (
    <ContentContainer>
      <StyledTitle>
        <TradeCardTitle
          testId={`${testId}-title`}
          tradeSummary={tradeSummary}
          onCardClick={onCardClick}
        />
        {isSellContext && (
          <KebabMenuSeller
            vin={vin}
            tradeId={tradeId}
            sellingNetworks={sellingNetworks}
            isOpenNetwork={isOpenNetwork}
            tradeSummary={tradeSummary}
            setPendingCardFooter={setPendingCardFooter}
            isNoNegotiationsYet={
              listCardVariant === PendingListCardVariant.DECISION
            }
            isOmp={isOmp}
          />
        )}
      </StyledTitle>
      <TradeHeader
        testId={testId}
        mileage={mileage}
        odometerType={
          odometerType === 0 ? DISTANCE_UNITS.KM : DISTANCE_UNITS.MI
        }
        transmission={
          typeof transmission?.id === 'number'
            ? getTransmissionType(transmission.id)
            : transmission
        }
        trim={trim}
      />
      <TradeDisclosures
        testId={testId}
        isAsIs={asIs}
        hasDisclosures={hasDisclosures}
        isLanded={inStock}
        showQnAIcon={hasChat}
      />
    </ContentContainer>
  );
};

Content.propTypes = propTypes;
Content.defaultProps = defaultProps;

export default Content;
